/* Hannovae: "Notify me" (Klaviyo back in stock) and Rouge early access, sent straight to Klaviyo.
   Markup comes from snippets/hnv-notify-me.liquid. Every Notify me sign-up also joins All Subscribers,
   which starts the welcome series (W1 sends WELCOME10 to new subscribers). */
(function () {
  if (window.hnvNotifyMe) return;
  window.hnvNotifyMe = true;

  var COMPANY = 'R7uCTa';          // Klaviyo public key (site ID)
  var REVISION = '2025-10-15';
  var NEWS_LIST = 'TQ9VcB';        // "All Subscribers", single opt-in
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function post(path, data) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + COMPANY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': REVISION },
      body: JSON.stringify({ data: data })
    }).then(function (res) {
      if (!res.ok) throw new Error('Klaviyo ' + res.status);
      return res;
    });
  }

  function subscribe(email, list, source) {
    return post('subscriptions', {
      type: 'subscription',
      attributes: {
        custom_source: source,
        profile: { data: { type: 'profile', attributes: { email: email } } }
      },
      relationships: { list: { data: { type: 'list', id: list } } }
    });
  }

  function backInStock(email, variantId) {
    return post('back-in-stock-subscriptions', {
      type: 'back-in-stock-subscription',
      attributes: {
        channels: ['EMAIL'],
        profile: { data: { type: 'profile', attributes: { email: email } } }
      },
      relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } }
    });
  }

  function identify(props) {
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify(props);
    } catch (e) {}
  }

  function show(box, state) {
    var parts = box.querySelectorAll('[data-hnv-state]');
    for (var i = 0; i < parts.length; i++) parts[i].hidden = parts[i].getAttribute('data-hnv-state') !== state;
  }

  function fromRougeEmail() {
    return /[?&]ref=rouge-list(&|$)/.test(window.location.search);
  }

  // Keep the right state when the theme re-renders the block for another size.
  function restore(root) {
    var boxes = (root || document).querySelectorAll('[data-hnv-nm][data-mode="early"]');
    for (var i = 0; i < boxes.length; i++) {
      if (window.hnvRougeJoined) show(boxes[i], 'done');
      else if (fromRougeEmail() && !window.hnvRougeOptOut) show(boxes[i], 'ref');
    }
  }

  function send(form) {
    var box = form.closest('[data-hnv-nm]');
    if (!box || box.hnvBusy) return;
    var err = form.querySelector('[data-hnv-error]');
    var btn = form.querySelector('[data-hnv-submit]');
    var emailEl = form.querySelector('input[name="email"]');
    var nameEl = form.querySelector('input[name="first_name"]');
    var email = (emailEl.value || '').trim();
    var first = nameEl ? (nameEl.value || '').trim() : '';

    err.hidden = true;
    emailEl.removeAttribute('aria-invalid');
    if (!EMAIL_RE.test(email)) {
      err.textContent = 'Please enter a valid email address.';
      err.hidden = false;
      emailEl.setAttribute('aria-invalid', 'true');
      emailEl.focus();
      return;
    }

    var mode = box.getAttribute('data-mode');
    var props = { email: email };
    if (first) props.first_name = first;
    var jobs = [];
    if (mode === 'early') {
      var size = box.getAttribute('data-size');
      if (size) props.rouge_size = size;
      jobs.push(subscribe(email, box.getAttribute('data-list'), 'Rouge early access, product page'));
    } else {
      jobs.push(backInStock(email, box.getAttribute('data-variant')));
      // Every Notify me sign-up joins the main list too. If that part fails, the restock request still goes through.
      jobs.push(subscribe(email, NEWS_LIST, 'Notify me, product page').catch(function () {}));
    }

    box.hnvBusy = true;
    btn.disabled = true;
    Promise.all(jobs).then(function () {
      identify(props);
      if (mode === 'early') window.hnvRougeJoined = true;
      show(box, 'done');
    }).catch(function () {
      err.textContent = 'That did not go through. Please try again.';
      err.hidden = false;
    }).then(function () {
      box.hnvBusy = false;
      btn.disabled = false;
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var submit = e.target.closest('[data-hnv-submit]');
    if (submit) {
      e.preventDefault();
      send(submit.closest('[data-hnv-form]'));
      return;
    }
    var other = e.target.closest('[data-hnv-show-form]');
    if (other) {
      window.hnvRougeOptOut = true;
      var box = other.closest('[data-hnv-nm]');
      show(box, 'form');
      var input = box.querySelector('input[name="first_name"], input[name="email"]');
      if (input) input.focus();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.closest) return;
    var form = e.target.closest('[data-hnv-form]');
    if (!form || e.target.tagName !== 'INPUT' || e.target.type === 'checkbox') return;
    e.preventDefault();
    send(form);
  });

  function start() {
    restore(document);
    if (!window.MutationObserver) return;
    var slots = document.querySelectorAll('.hnv-nm-slot');
    for (var i = 0; i < slots.length; i++) {
      (function (slot) {
        new MutationObserver(function () { restore(slot); }).observe(slot, { childList: true });
      })(slots[i]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();